import { useEffect, useState } from "react";
import { createRoot } from "react-dom/client";   // React 18. На React 17 см. примечание внизу файла.

function DuplicatePhotoDialog({ detail, onResult }) {
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const raf = requestAnimationFrame(() => setShown(true));   // плавное появление
    const onKey = (e) => { if (e.key === "Escape") onResult(false); };
    document.addEventListener("keydown", onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [onResult]);

  return (
    <div
      onMouseDown={(e) => { if (e.target === e.currentTarget) onResult(false); }}
      style={{
        position: "fixed", inset: 0, zIndex: 100000,
        background: "rgba(0,0,0,0.55)",
        display: "flex", alignItems: "center", justifyContent: "center",
        padding: 16,
        opacity: shown ? 1 : 0,
        transition: "opacity 0.18s ease",
        WebkitTapHighlightColor: "transparent",
      }}
    >
      <div
        role="dialog"
        aria-modal="true"
        style={{
          width: "100%", maxWidth: 380,
          background: "#fff", borderRadius: 18,
          boxShadow: "0 20px 60px rgba(0,0,0,0.35)",
          padding: 24,
          transform: shown ? "translateY(0) scale(1)" : "translateY(8px) scale(0.98)",
          transition: "transform 0.2s cubic-bezier(0.22,1,0.36,1)",
        }}
      >
        <div style={{ fontSize: 18, fontWeight: 800, color: "#1a1a1a", marginBottom: 8 }}>
          Похоже, фото повторяется
        </div>

        <div style={{ fontSize: 15, lineHeight: 1.5, color: "#3a3640", marginBottom: 22 }}>
          {detail || "Это фото уже добавлено в эту книгу."}
        </div>

        <div style={{ display: "flex", gap: 12, justifyContent: "flex-end" }}>
          <button
            type="button"
            onClick={() => onResult(false)}
            style={{
              padding: "10px 18px", borderRadius: 12, border: "none",
              background: "#eceff1", color: "#333", fontSize: 15, fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Заменить
          </button>
          <button
            type="button"
            onClick={() => onResult(true)}
            style={{
              padding: "10px 22px", borderRadius: 12, border: "none",
              background: "#1f2933", color: "#fff", fontSize: 15, fontWeight: 700,
              cursor: "pointer",
            }}
          >
            Оставить
          </button>
        </div>
      </div>
    </div>
  );
}

export function confirmDuplicatePhotoModal(detail) {
  return new Promise((resolve) => {
    const host = document.createElement("div");
    document.body.appendChild(host);

    const root = createRoot(host);
    let resolved = false;
    const finish = (result) => {
      if (resolved) return;
      resolved = true;
      root.unmount();
      host.remove();
      resolve(result);
    };

    root.render(<DuplicatePhotoDialog detail={detail} onResult={finish} />);
  });
}